export default __webpack_public_path__ + "static/media/flower-top-big.0b92c3d1.png";